import React from 'react';
import * as PropTypes from 'prop-types';
import { Wrapper, Composite, Avatar, Name } from './elements';
import { Typ20 } from 'dc/Typ';
import Lab010 from 'dc/Lab010';

function LIC001(props) {
  return (
    <Wrapper className={props.className}>
      <Avatar image={props.avatarImage} isLoading={props.loadingImage} />
      <Composite>
        <Name>{props.userName}</Name>
        {props.icon ? (
          <Lab010 icon={props.icon}>{props.caption}</Lab010>
        ) : (
          <Typ20>{props.caption}</Typ20>
        )}
      </Composite>
    </Wrapper>
  );
}

LIC001.propTypes = {
  avatarImage: PropTypes.string,
  caption: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string,
  loadingImage: PropTypes.bool,
  userName: PropTypes.string,
};

export default LIC001;
